import { useMemo } from 'react'

import { useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import BulkSelectImagesModal from '@modals/BulkSelectImagesModal'
import SelectEmailRecipientModal from '@modals/SelectEmailRecipientModal'
import SelectSMSRecipientModal from '@modals/SelectSMSRecipientModal'

import type { CampaignModel } from '@models/types'

import handleCallbackAction, { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import PageContent from './components/PageContent'

const defaultState = {
  showBulkSelectImagesModal: false,
  showSelectEmailRecipientModal: false,
  showSelectSMSRecipientModal: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

/* eslint-disable no-undef */
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    BulkSelectImagesModal: {
      closeModal: () => setState({ showBulkSelectImagesModal: false }),
      updateEntity: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
    SelectEmailRecipientModal: {
      closeModal: () => setState({ showSelectEmailRecipientModal: false }),
      emailDashboardLink: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
    SelectSMSRecipientModal: {
      closeModal: () => setState({ showSelectSMSRecipientModal: false }),
      shareMobileLink: (payload: HandleCallbackActionParams) => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const List = ({ campaign }: { campaign: CampaignModel }) => {
  const [state, setState] = useSetState(defaultState)
  const {
    showBulkSelectImagesModal,
    showSelectEmailRecipientModal,
    showSelectSMSRecipientModal,
  } = state

  const modalContext = useModals({ setState })
  const { callbacks: { setModalData } } = modalContext

  const pageContext = useMemo(() => ({
    callbacks: {
      showBulkSelectImagesModal: (payload: { campaign: CampaignModel }) => {
        setModalData('BulkSelectImagesModal', payload)
        setState({ showBulkSelectImagesModal: true })
      },
      showSelectEmailRecipientModal: (payload: { campaign: CampaignModel }) => {
        setModalData('SelectEmailRecipientModal', payload)
        setState({ showSelectEmailRecipientModal: true })
      },
      showSelectSMSRecipientModal: (payload: { campaign: CampaignModel }) => {
        setModalData('SelectSMSRecipientModal', payload)
        setState({ showSelectSMSRecipientModal: true })
      },
    },
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent campaign={campaign} />

        <BulkSelectImagesModal
          // @ts-expect-error TS2322
          callbacks={callbacks('BulkSelectImagesModal', setState)}
          showModal={showBulkSelectImagesModal}
        />

        <SelectEmailRecipientModal
          // @ts-expect-error TS2322
          callbacks={callbacks('SelectEmailRecipientModal', setState)}
          showModal={showSelectEmailRecipientModal}
        />

        <SelectSMSRecipientModal
          // @ts-expect-error TS2322
          callbacks={callbacks('SelectSMSRecipientModal', setState)}
          showModal={showSelectSMSRecipientModal}
        />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
